module.exports = __webpack_public_path__ + "img/11.9700e640.png";